import React, { useRef, useState } from "react"
import { css, StyleSheet } from "aphrodite"
import UIFx from "uifx"

const buzz = new UIFx(process.env.PUBLIC_URL + "/sounds/buzz.mp3", {
  volume: 0.6,
  throttleMs: 100,
})

const Styles = StyleSheet.create({
  button: {
    position: "absolute",
    backgroundColor: "rgb(0,0,0,0.0)",
    width: 26,
    height: 26,
    ":hover": {
      backgroundColor: "red",
    },
  },
  correctButton: {
    position: "absolute",
    border: "1px solid white",
    backgroundColor: "green",
    width: 26,
    height: 26,
    ":hover": {
      backgroundColor: "green",
    },
  },
  label: {
    position: "absolute",
    fontSize: 8,
    fontWeight: 900,
    textShadow:
      "rgb(255, 255, 255) 3px 0px 0px, rgb(255, 255, 255) 2.83487px 0.981584px 0px, rgb(255, 255, 255) 2.35766px 1.85511px 0px, rgb(255, 255, 255) 1.62091px 2.52441px 0px, rgb(255, 255, 255) 0.705713px 2.91581px 0px, rgb(255, 255, 255) -0.287171px 2.98622px 0px, rgb(255, 255, 255) -1.24844px 2.72789px 0px, rgb(255, 255, 255) -2.07227px 2.16926px 0px, rgb(255, 255, 255) -2.66798px 1.37182px 0px, rgb(255, 255, 255) -2.96998px 0.42336px 0px, rgb(255, 255, 255) -2.94502px -0.571704px 0px, rgb(255, 255, 255) -2.59586px -1.50383px 0px, rgb(255, 255, 255) -1.96093px -2.27041px 0px, rgb(255, 255, 255) -1.11013px -2.78704px 0px, rgb(255, 255, 255) -0.137119px -2.99686px 0px, rgb(255, 255, 255) 0.850987px -2.87677px 0px, rgb(255, 255, 255) 1.74541px -2.43999px 0px, rgb(255, 255, 255) 2.44769px -1.73459px 0px, rgb(255, 255, 255) 2.88051px -0.838247px 0px",
    transform: "rotate(-25deg)",
    pointerEvents: "none",
  },
})

interface Props {
  top: number
  left: number
  onClick: (rightAnswer: boolean) => void
  rightAnswer?: boolean
}

export const QuizButton: React.FC<Props> = (props) => {
  const [showWongLabel, setShowWrongLabel] = useState(false)
  const [showRightLabel, setShowRightLabel] = useState(false)
  const { top, left, onClick, rightAnswer } = props
  const ref = useRef<HTMLButtonElement>(null)

  const handleMouseDown = () => {
    if (rightAnswer) {
      setShowRightLabel(true)
      setTimeout(() => {
        setShowRightLabel(false)
        onClick(true)
      }, 500)
    } else {
      buzz.play()
      setShowWrongLabel(true)
      setTimeout(() => {
        setShowWrongLabel(false)
      }, 500)
      onClick(false)
    }
  }

  const handleMouseUp = () => {
    setShowWrongLabel(false)
    setShowRightLabel(false)
    ref.current?.blur()
  }

  const buttonStyles = showRightLabel ? Styles.correctButton : Styles.button

  return (
    <div>
      <button
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        ref={ref}
        className={css(buttonStyles)}
        style={{ top, left }}
      ></button>
      {showWongLabel && (
        <div style={{ top, left: left - 8 }} className={css(Styles.label)}>
          <div>WRONG</div>
          <div>try again</div>
        </div>
      )}
      {showRightLabel && (
        <div
          style={{ top: top + 7, left: left - 8 }}
          className={css(Styles.label)}
        >
          <div>RIGHT ON!!</div>
        </div>
      )}
    </div>
  )
}
